// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"ContentfulVideo-module--playerWrapper--1i2U_","reactPlayer":"ContentfulVideo-module--reactPlayer--2-a3i"};